"use strict";
exports.__esModule = true;
exports.INCOME_ACCOUNTS = void 0;
var INCOME_ACCOUNTS = {
    SUPERANNUATION: 'superannuation',
    INTEREST_EARNED: 'interestEarned',
    DIVIDENDS: 'dividends',
    SHARES_VALUE: 'sharesValue',
    RENTAL_INCOME: 'rentalIncome',
    GOVERNMENT_PAYMENT: 'governmentPayment',
    SALARY: 'salary',
    SELF_EMPLOYED: 'selfEmployed',
    OTHER: 'other',
    GIFTS: 'gifts',
    CHILD_SUPPORT: 'childSupport',
    COMPANY_PROFIT: 'companyProfitBeforeTax'
};
exports.INCOME_ACCOUNTS = INCOME_ACCOUNTS;
